import {
  Box,
  Button,
  Flex,
  Link,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { Trans, useTranslation } from 'react-i18next';
import EmailAndCollaborationProtection from '../components/EmailAndCollaborationProtection';
import GradientBackground from '../components/GradientBackground';
import dashboardPreview from '@Welcome/EmailAndCollaboration/FoundationBasedEnableEmailAndCollaboration/images/dashboard-preview.svg';

const FoundationBasedEnableApiLayerProtection = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();

  return (
    <Box
      position="relative"
      width="100%"
      minHeight="100vh"
      backgroundColor={colorStyle.background.primary}
    >
      <GradientBackground />

      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="flex-start"
        width="100%"
        minHeight="100vh"
        px="96px"
        py="64px"
        position="relative"
        zIndex={1}
      >
        {/* Main Content */}
        <Box width="100%" maxWidth="832px" mb="24px">
          {/* eslint-disable-next-line @typescript-eslint/no-empty-function */}
          <EmailAndCollaborationProtection setLoading={() => {}} />
        </Box>

        {/* Get Started Button (disabled) with hover popover */}
        <Box width="100%" maxWidth="832px" mb="32px" textAlign="center">
          <Popover trigger="hover">
            <PopoverTrigger>
              <Box display="inline-block">
                <Button variant="secondary" disabled>
                  <Text fontSize="14px">
                    {t('welcome.blockingPage.getStarted')}
                  </Text>
                </Button>
              </Box>
            </PopoverTrigger>
            <PopoverContent width="320px" textAlign="left">
              <PopoverBody p="4px">
                <Text
                  fontSize="14px"
                  lineHeight="20px"
                  color={colorStyle.color.primary}
                >
                  {t('welcome.blockingPage.getStarted.hover.title')}
                </Text>
                <Text
                  fontSize="14px"
                  lineHeight="20px"
                  color={colorStyle.color.primary}
                  mt="12px"
                >
                  <Trans i18nKey="welcome.blockingPage.getStarted.hover.desc">
                    placeholder
                    <Link
                      href="https://resources.trendmicro.com/vision-one-callback.html"
                      target="_blank"
                    />
                    <Link
                      href="https://docs.trendmicro.com/en-us/documentation/article/trend-vision-one-credits-billing"
                      target="_blank"
                    />
                  </Trans>
                </Text>
              </PopoverBody>
            </PopoverContent>
          </Popover>
        </Box>

        {/* Hero Graphic */}
        <Box width="100%" maxWidth="832px" position="relative">
          <img
            src={dashboardPreview}
            alt="Hero graphic"
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default FoundationBasedEnableApiLayerProtection;
